export const devToastMessage = (message: string = "") => {
  let brileString =
    "⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠇⠇⠇⠇⠇⠇⠇⠇⠇⠃⠃⠃⠃⠃⠃⠃⠃⠃⠃⠃⠃⠁⠁⠁⠁⠁⠁⠁⠁⠁⠁⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠇⠇⠇⠇⠇⠇⠇⠇⠇⠃⠃⠃⠃⠃⠃⠃⠃⠃⠃⠃⠃⠁⠁⠁⠁⠁⠁⠁⠁⠁⠁⠁";
  const reveresString = `⠁⠁⠁⠁⠁⠁⠁⠁⠁⠁⠁⠃⠃⠃⠃⠃⠃⠃⠃⠃⠃⠃⠃⠇⠇⠇⠇⠇⠇⠇⠇⠇⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠁⠁⠁⠁⠁⠁⠁⠁⠁⠁⠃⠃⠃⠃⠃⠃⠃⠃⠃⠃⠃⠃⠇⠇⠇⠇⠇⠇⠇⠇⠇⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠼⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠾⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿    `;
  brileString = brileString + reveresString;
  const numOfChars = 9;
  const deleteDiv = () => {
    let div: HTMLDivElement = document.querySelector(
      "#div-for-showing-autu-fill"
    ) as HTMLDivElement;
    if (div) {
      div.remove();
      // this.AutoFillFormDev_Continue(bindDataObject, childTables, ListCodes)
    }
  };
  const moveDiv = () => {
    let div: HTMLDivElement = document.querySelector(
      "#div-for-showing-autu-fill"
    ) as HTMLDivElement;
    if (div) {
      //   div.style.transform = 'translateX(-1200px)'
      div.style.opacity = "0";
      setTimeout((_) => deleteDiv(), 1000);
    }
  };
  const cahngeBrile = (charNum: number) => {
    setTimeout((_) => {
      let span = document.querySelector("#auto-fill-text-icons");
      let str = brileString.slice(charNum - numOfChars, charNum);
      span.innerHTML = str;

      if (charNum > numOfChars + 1) {
        cahngeBrile(charNum - 1);
      } else {
        moveDiv();
      }
    }, 6);
  };
  let FillTypeText = message;
  let heightOfDiv = 100 + FillTypeText.length * 2;

  const exsitingDiv = document.querySelector("#div-for-showing-autu-fill");
  let popupDiv = exsitingDiv || document.createElement("DIV");
  if (!exsitingDiv) {
    popupDiv.innerHTML =
      `<div id="div-for-showing-autu-fill" style="position: fixed; background-color: #80cbff; top:100px; left: 100px; width: 200px;  opacity : 1; transition: all .5s ease-in-out; padding: 5px 20px 20px;font-family: Assistant, sans-serif; font-size: 20px;transform: translateX(0px) ;z-index: 50000; border-radius: 20px;box-shadow:0 5px 5px -3px rgba(0, 0, 0, 0.246), 0 8px 10px 1px rgba(0, 0, 0, 0.164),\n` +
      `0 3px 14px 2px rgba(0, 0, 0, 0.144);"> <div style="margin: 10px;">מילוי אוטומטי ${FillTypeText}</div><div id="auto-fill-text-icons" dir="rtl">  </div> </div>`;
  }

  let body = document.querySelector("body");
  cahngeBrile(brileString.length);
  if (exsitingDiv) {
    return;
  }
  body.appendChild(popupDiv);
};



// WEBPACK FOOTER //
// ./src/app/_helpers/devToastMessage.ts